/**
 * AM.One API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Group-only node in the complete hierarchy. Concepts are never present. Subgroups are deterministically sorted by ascending group ID and are never null; leaf nodes return an empty array `[]`.
 */
export interface GroupTreeNode { 
    id: string;
    type: GroupTreeNode.TypeEnum;
    name: string;
    /**
     * Latest Git commit author for the group file, when available.
     */
    lastEditedBy?: string | null;
    /**
     * Date the group document was last modified, when available.
     */
    lastModified?: string | null;
    /**
     * Timestamp of the latest Git commit for the group file, when available.
     */
    commitTimestamp?: string | null;
    description?: string | null;
    icon?: string | null;
    subgroups: Array<GroupTreeNode>;
}
export namespace GroupTreeNode {
    export const TypeEnum = {
        Group: 'group'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


